export const GET_VEHICLE_OWNER_PENDING = "GET_VEHICLE_OWNER_PENDING"
export const GET_VEHICLE_OWNER_SUCCESS = "GET_VEHICLE_OWNER_SUCCESS"
export const GET_VEHICLE_OWNER_FAILURE = "GET_VEHICLE_OWNER_FAILURE"

export const ADD_VEHICLE_OWNER_PENDING = "ADD_VEHICLE_OWNER_PENDING"
export const ADD_VEHICLE_OWNER_SUCCESS = "ADD_VEHICLE_OWNER_SUCCESS"
export const ADD_VEHICLE_OWNER_FAILURE = "ADD_VEHICLE_OWNER_FAILURE"

export const UPLOAD_VEHICLE_OWNER_PENDING = "UPLOAD_VEHICLE_OWNER_PENDING"
export const UPLOAD_VEHICLE_OWNER_SUCCESS = "UPLOAD_VEHICLE_OWNER_SUCCESS"
export const UPLOAD_VEHICLE_OWNER_FAILURE = "UPLOAD_VEHICLE_OWNER_FAILURE"

export const EDIT_VEHICLE_OWNER_PENDING = "EDIT_VEHICLE_OWNER_PENDING"
export const EDIT_VEHICLE_OWNER_SUCCESS = "EDIT_VEHICLE_OWNER_SUCCESS"
export const EDIT_VEHICLE_OWNER_FAILURE = "EDIT_VEHICLE_OWNER_FAILURE"

export const DELETE_VEHICLE_OWNER_PENDING = "DELETE_VEHICLE_OWNER_PENDING"
export const DELETE_VEHICLE_OWNER_SUCCESS = "DELETE_VEHICLE_OWNER_SUCCESS"
export const DELETE_VEHICLE_OWNER_FAILURE = "DELETE_VEHICLE_OWNER_FAILURE"

export const DOWNLOAD_VEHICLE_OWNER_PENDING = "DOWNLOAD_VEHICLE_OWNER_PENDING"
export const DOWNLOAD_VEHICLE_OWNER_SUCCESS = "DOWNLOAD_VEHICLE_OWNER_SUCCESS"
export const DOWNLOAD_VEHICLE_OWNER_FAILURE = "DOWNLOAD_VEHICLE_OWNER_FAILURE"
